var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Arrow circle down",
    clipPath: "url(#clip0_212_515)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M32.5 10.8334C44.4437 10.8334 54.1666 20.5563 54.1666 32.5001C54.1666 44.4438 44.4437 54.1668 32.5 54.1668C20.5562 54.1668 10.8333 44.4438 10.8333 32.5001C10.8333 20.5563 20.5562 10.8334 32.5 10.8334ZM32.5 5.41675C17.55 5.41675 5.41663 17.5501 5.41663 32.5001C5.41663 47.4501 17.55 59.5834 32.5 59.5834C47.45 59.5834 59.5833 47.4501 59.5833 32.5001C59.5833 17.5501 47.45 5.41675 32.5 5.41675ZM35.2083 32.5001V21.6667H29.7916V32.5001H21.6666L32.5 43.3334L43.3333 32.5001H35.2083Z",
    fill: "#D3D3D3",
    fillOpacity: 0.8
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_212_515"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 65,
    height: 65,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow_down.efab6b925ed34ac4ac3bd64bde0b4461.svg";
export { ForwardRef as ReactComponent };